import styled from 'styled-components';
import { BodyText, FlexRow } from '@make-software/cspr-design';
import { Icon } from '@iconify/react';
import { useNavigate } from 'react-router-dom';

export const StyledContainer = styled.div(({ theme }) =>
  theme.withMedia({
    padding: ['40px 0 0 0', '40px 0 0 0', '40px'],
    width: ['100%', '70%', '95%']
  })
);

export const StyledTableHeader = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    marginBottom: '24px'
  })
);

export const StyledNavigation = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    color: theme.styleguideColors.fillPrimaryBlue,
    cursor: 'pointer',
    gap: '4px',
    padding: '4px 0px',
    alignItems: 'center'
  })
);

export const NavigationElement = ({ title, path }: { title: string; path: string }) => {
  const navigate = useNavigate();
  return (
    <StyledNavigation
      onClick={() => {
        navigate(path);
      }}
    >
      <Icon icon={'material-symbols:arrow-back'} width="16" height="16" />
      <BodyText size={1} scale={'sm'}>
        {title}
      </BodyText>
    </StyledNavigation>
  );
};
